/** Centralised route paths for the merchant dashboard. */
export const paths = {
  dashboard: '/dashboard',
  returns: '/returns',
  returnDetail: (returnId: string) => `/returns/${encodeURIComponent(returnId)}`,
  exchanges: '/exchanges',
  refunds: '/refunds',
  qc: '/qc',
  exceptions: '/exceptions',
  analytics: '/analytics',
  blocklist: '/blocklist',
  autopilot: '/autopilot',
  settings: '/settings',
  manualReturn: '/manual-return',
} as const;

export const routePatterns = {
  returnDetail: '/returns/:returnId',
} as const;
